export function addSiteLabelToHeap() {
	if (window.modForm.opts.isBestCompany) {
		return;
	}

	let siteLabel = null;

	if (window.modForm.opts.isBranded && !window.modForm.opts.isLeadForm) {
		siteLabel = 'Branded';
	} else if (window.modForm.opts.isModernize) {
		siteLabel = 'Modernize';
	} else if (window.modForm.opts.isCallOnly) {
		siteLabel = 'Non-Branded_Call-Only';
	} else {
		siteLabel = 'Non-Branded';
	}

	if (siteLabel) {
		const properties = {
			siteLabel: siteLabel
		};

		window.Modalytics.heap('addEventProperties', properties);
		window.Modalytics.heap('addUserProperties', properties);
	}
}
